module.exports = __webpack_public_path__ + "static/media1-fcc4aac8017ae7523e8302bc43af2725.jpg";